export default "/_next/static/chunks/fonts/WhitneySSm-BoldItalic-Pro_Web-0ae8e244935da55c0a33ae6bc8045098.woff";